export default {"src":"/_next/static/media/faq_logo.82b317f7.svg","height":2874,"width":3022,"blurWidth":0,"blurHeight":0};